import { render, staticRenderFns } from "./NewShopWeb.vue?vue&type=template&id=011cf84a&scoped=true&"
import script from "./NewShopWeb.vue?vue&type=script&lang=js&"
export * from "./NewShopWeb.vue?vue&type=script&lang=js&"
import style0 from "./NewShopWeb.vue?vue&type=style&index=0&id=011cf84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011cf84a",
  null
  
)

export default component.exports